import { createAction } from '@reduxjs/toolkit';
import { SmoLanguage } from '../../../../Models/Smo/SmoLanguage';

const updateLanguage = createAction<SmoLanguage>('SMO_LANGUAGE_MENU_UPDATE_LANGUAGE');

export default {
  updateLanguage
};
